import { useContext } from 'react';
import { FormContext } from '../context';
import { FormMethods } from '../types';

export const useFormInstance = () => {
  const { form } = useContext(FormContext);
  return form as FormMethods;
};
